import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ index, children, dark = false }) => (
  <div className="flex items-center gap-4 mb-7" data-testid="section-overline">
    {index && (
      <span className="font-heading text-xs font-bold tabular-nums text-nero-green">{index}</span>
    )}
    <span className="h-px w-7 bg-nero-green" />
    <span
      className={`font-body text-xs uppercase tracking-[0.22em] font-semibold ${
        dark ? "text-white/55" : "text-zinc-500"
      }`}
    >
      {children}
    </span>
  </div>
);
